import React, { useEffect } from 'react'
import ContentAwards from '../components/organisms/content-awards/content-awards'
import PageLayout from '../components/templates/page-layout/page-layout'

import { jsonToHash } from '../utils/crypto'
import getUserInfo from '../utils/getUserInfo'
import { pushEventData } from '../utils/pushEventDataLayer'

const PremiosPage = () => {
  const userInfo = getUserInfo()

  const handleDataLayer = async () => {
    pushEventData({
      event: 'Interacciones_Premios_UCole',
      label: 'www.nosotrasonline.com.co/universo-cole/premios',
      action: 'view',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  useEffect(() => {
    handleDataLayer()
  }, [])

  return (
    <PageLayout>
      <ContentAwards />
    </PageLayout>
  )
}
export default PremiosPage
